export interface Spec {
    label: string
    value: string
}

export interface SpecGroup {
    title: string
    specs: Spec[]
}

export const SWITCH_SPECS: Spec[][] = [
    [
        { label: 'Operating force', value: '42 ± 15 gf' },
        { label: 'End force', value: '55 ± 15 gf' },
        { label: 'Pre-travel', value: '1.7 ± 0.4 mm' }
    ],
    [
        { label: 'Total travel', value: '3.2 ± 0.2 mm' },
        { label: 'Type', value: 'Linear' }
    ]
]

export const SIZE_AND_WEIGHT: SpecGroup = {
    title: 'Size & Weight',
    specs: [
        { label: 'Dimensions', value: '318.9 mm × 128.9 mm × 13.2 mm' },
        { label: 'Weight', value: '724 g' },
        { label: 'Typing angle', value: '4° / 8° / 10°' }
    ]
}

export const SPECIFICATION: SpecGroup = {
    title: 'Specification',
    specs: [
        { label: 'Layout', value: 'ANSI 75%' },
        { label: 'Number of keys', value: '85' },
        { label: 'Switch type', value: 'Low profile' },
        { label: 'Stabilizer type', value: 'Plate mounted' },
        { label: 'Mount type', value: 'Gasket' },
        { label: 'Backlight', value: 'RGB LED' },
        { label: 'Battery capacity', value: '4,000 mAh' }
    ]
}

export const CONNECTION: SpecGroup = {
    title: 'Connection',
    specs: [
        { label: 'Mode', value: '2.4 GHz, USB-C, or Bluetooth 5.0' },
        { label: '2.4 GHz polling rate', value: '1,000 Hz' },
        { label: 'Wired polling rate', value: '1,000 Hz' },
        { label: 'Bluetooth polling rate', value: '125 Hz' }
    ]
}

export const MATERIALS: SpecGroup = {
    title: 'Materials',
    specs: [
        { label: 'Top case', value: 'Aluminium' },
        { label: 'Bottom case', value: 'ABS' },
        { label: 'Plate material', value: 'PC' },
        { label: 'Keycaps', value: 'Double-shot' }
    ]
}
